$giper_baza_pawn_dump $mol_expander
	pawn $giper_baza_pawn
		can_change => can_change
		land => land
	tag \keys
	label /
		<= Head $mol_paragraph sub / <= title \
	addons /
	Tools $mol_view sub /
		^ addons
		- ^ editors
	editors /
		<= Add_key $mol_textarea
			enabled <= can_change
			hint \+
			value? <=> key_new? \
			submit? <=> add_key? null
		<= Add_value $mol_textarea
			enabled <= can_change
			hint \+
			value? <=> value_new? \
			submit? <=> add_value? null
		<= Value_text $mol_textarea
			enabled <= can_change
			value? <=> text? \
		<= Value_str $mol_textarea
			enabled <= can_change
			value? <=> value_str? \
	content <= pawns /
		<= Inner*0 $mol_view sub /
			<= Pawn_inner* $giper_baza_pawn_dump
				tag <= unit_tag*
				addons <= pawn_addons* /
					<= Unit_tag* $mol_select
						value? <=> unit_tag*? \term
						enabled <= can_change
						dictionary *
							term \💼 term
							solo \🔝 solo
							vals \🎹 vals
							keys \🔑 keys
					<= Unit_time* $mol_view sub / <= unit_time* \
					<= Unit_value* $giper_baza_unit_sand_dump
						land <= land
						sand <= unit_value* null
						enabled <= can_change
				pawn <= pawn_inner* $giper_baza_pawn
